var map = {
	"./emoji_00@2x.png": "d9c0",
	"./emoji_01@2x.png": "67d6",
	"./emoji_02@2x.png": "5675",
	"./emoji_03@2x.png": "657c",
	"./emoji_04@2x.png": "01da",
	"./emoji_05@2x.png": "1dc2",
	"./emoji_06@2x.png": "c9cd",
	"./emoji_07@2x.png": "1823",
	"./emoji_08@2x.png": "c9e8",
	"./emoji_09@2x.png": "9862",
	"./emoji_10@2x.png": "80ea",
	"./emoji_11@2x.png": "1afb",
	"./emoji_12@2x.png": "c70e",
	"./emoji_13@2x.png": "558f",
	"./emoji_14@2x.png": "5b4d",
	"./emoji_15@2x.png": "3114",
	"./emoji_16@2x.png": "be91",
	"./emoji_17@2x.png": "be74",
	"./emoji_18@2x.png": "c4ef",
	"./emoji_19@2x.png": "e4e5",
	"./emoji_20@2x.png": "b819",
	"./emoji_21@2x.png": "4705",
	"./emoji_22@2x.png": "8b15",
	"./emoji_23@2x.png": "70e0",
	"./emoji_24@2x.png": "869f",
	"./emoji_25@2x.png": "efa7",
	"./emoji_26@2x.png": "cb2b",
	"./emoji_27@2x.png": "c9f0",
	"./emoji_28@2x.png": "47c2",
	"./emoji_29@2x.png": "7aac",
	"./emoji_30@2x.png": "2b7e",
	"./emoji_31@2x.png": "a626",
	"./emoji_32@2x.png": "f2b3",
	"./emoji_33@2x.png": "5088",
	"./emoji_34@2x.png": "ea9c",
	"./emoji_35@2x.png": "9b5c",
	"./emoji_36@2x.png": "5919",
	"./emoji_37@2x.png": "3da1",
	"./emoji_38@2x.png": "3133",
	"./emoji_39@2x.png": "d17f",
	"./emoji_40@2x.png": "ce44",
	"./emoji_41@2x.png": "a56e",
	"./emoji_42@2x.png": "0e65",
	"./emoji_43@2x.png": "23d1",
	"./emoji_44@2x.png": "11e1",
	"./emoji_45@2x.png": "e0d8",
	"./emoji_46@2x.png": "cf39",
	"./emoji_47@2x.png": "e7ac",
	"./emoji_48@2x.png": "6b67",
	"./emoji_49@2x.png": "113c",
	"./emoji_50@2x.png": "23dc",
	"./emoji_51@2x.png": "e1aa",
	"./emoji_52@2x.png": "1f1a",
	"./emoji_53@2x.png": "28e3",
	"./emoji_54@2x.png": "afc9",
	"./emoji_55@2x.png": "0602",
	"./emoji_56@2x.png": "d91b",
	"./emoji_57@2x.png": "1ea1",
	"./emoji_58@2x.png": "3799",
	"./emoji_59@2x.png": "cf65",
	"./emoji_60@2x.png": "d0dd",
	"./emoji_61@2x.png": "92c4",
	"./emoji_62@2x.png": "1891",
	"./emoji_63@2x.png": "0feb6",
	"./emoji_64@2x.png": "acee",
	"./emoji_65@2x.png": "0e2f",
	"./emoji_66@2x.png": "b83d",
	"./emoji_67@2x.png": "4f8d",
	"./emoji_68@2x.png": "aa9f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf76";